<template>
  <div class="relative hero-container text-[var(--foreground)]">
    <div
      v-if="!isMobile"
      class="z-10 -mt-20 absolute inset-0 [mask-image:radial-gradient(circle_10vw_at_var(--pointerX)_var(--pointerY),rgba(111,0,255,1)_0%,rgba(111,0,255,0.3)_100%)]"
      ref="maskHeroContainer"
    >
      <img
        alt="grid"
        src="/images/grid.webp"
        width="774"
        height="604"
        loading="eager"
        fetchpriority="high"
      />
      
    </div>
    <div class="relative max-w-screen-xl mx-auto">
      <div
        class="absolute -left-80 -top-[500px]  rounded-full bg-[image:var(--bg-circle-large)] opacity-50"
      ></div>
      <div
        class="absolute -right-32 top-[300px]  rounded-full bg-[image:var(--bg-circle-subtle)] opacity-60"
      ></div>

      <div
        class="z-10 absolute -right-[294px] top-80 size-[300px] rounded-full bg-[image:var(--bg-circle-top-light)] rotate-[135deg]"
      ></div>
      <span
          class="size-[463px] bg-[#F6E9FF] dark:bg-[#47116B] rounded-full blur-[150px] absolute -top-40 left-full"
      ></span>
      <span
          class="size-[463px] dark:bg-[#47116B] bg-[#F6E9FF] rounded-full blur-[150px] absolute -top-40 -left-80"
      ></span>
    </div>

    <section
      class="relative py-10 max-sm:pt-0 lg:pb-40 overflow-hidden grid place-items-center"
    >
      <div class="container mx-auto px-4 relative z-10">
        <div class="text-center">
          <h1 class="text-3xl md:text-5xl lg:text-[78px] mb-4 md:mb-8">
            <WrGradientText
              text="AI-driven development"
              append-class="pb-0 lg:pb-2"
            />
            <span class="text-[var(--foreground)]">
              transforming the future of tech.
            </span>
          </h1>

          <p class="text-lg lg:text-2xl tracking-[0.5px] font-anvtgrade-book">
            High-impact software that reduces budgets, accelerates timelines,
            and boost software efficiency.
          </p>
            <WrOfficialPartners
              :eager="true"
              :append-class="'mt-8 md:mt-16 px-4 py-5 md:px-8 md:py-6 dark:bg-[linear-gradient(92.4deg,_rgba(53,9,91,0.7)_6.22%,_rgba(63,0,119,0.7)_93.78%)]'"
              :title="'Official Partner Of'"
              :partnersAppendClass="'justify-center items-center'"
            />
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
const { isMobile } = useDevice();

import { ref, onMounted, onUnmounted } from "vue";

const WrGradientText = defineAsyncComponent(() => import('~/components/global/WrGradientText.vue'));
const WrOfficialPartners = defineAsyncComponent(() => import('~/components/molecules/WrOfficialPartners.vue'));

const maskHeroContainer = ref(null);

function handleMouseMove(e) {
  if (!maskHeroContainer.value) return;

  const rect = maskHeroContainer.value.getBoundingClientRect();
  const x = ((e.clientX - rect.left) / rect.width) * 100;
  const y = ((e.clientY - rect.top) / rect.height) * 100;

  maskHeroContainer.value.style.setProperty("--pointerX", `${x}%`);
  maskHeroContainer.value.style.setProperty("--pointerY", `${y}%`);
}

function initDefaultPosition() {
  if (!maskHeroContainer.value) return;
}

onMounted(() => {
  initDefaultPosition();

  const container = document.querySelector(".hero-container");
  if (container) {
    container.addEventListener("mousemove", handleMouseMove, { passive: true });
  }
});

onUnmounted(() => {
  const container = document.querySelector(".hero-container");
  if (container) {
    container.removeEventListener("mousemove", handleMouseMove);
  }
});
</script>
